import React, { useEffect, useState, useRef, useCallback } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import InfoIcon from "../support_files/InfoIcon";
import HelpIcon from "../support_files/HelpIcon";
import ToggleButton from '@mui/material/ToggleButton';

import FavoriteIcon from '@mui/icons-material/Favorite';
import CancelIcon from '@mui/icons-material/Cancel';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import TocIcon from '@mui/icons-material/Toc';
import SourceIcon from '@mui/icons-material/Source';

import Fade from '@mui/material/Fade';

import Tooltip from '@mui/material/Tooltip';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useTheme } from '@mui/material/styles';

import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';

import { ResponsivePie } from '@nivo/pie'
import { ResponsiveLine } from '@nivo/line'

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import genderInfoData from "../info_data/genderInfoData.json"
import sexualityInfoData from "../info_data/sexualityInfoData.json"
import marriageInfoData from "../info_data/marriageInfoData.json"

import { createTheme, ThemeProvider } from '@mui/material/styles';

import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';



export function GenderInfoDrawer({
  genderInfo, setGenderInfo,
}) {

  const headerRef = useRef(null);
  const handleScroll = useCallback((event) => {
    const scrollTop = event.target.scrollTop;
    if (headerRef.current) {
      if (scrollTop > 20) {
        headerRef.current.classList.add('header-translucent');
        headerRef.current.classList.remove('header-solid');
      } else {
        headerRef.current.classList.add('header-solid');
        headerRef.current.classList.remove('header-translucent');
      }
    }
  }, []); // Empty dependency array since we're using refs

  const GenderPie = (() => {

    const [animatedData, setAnimatedData] = useState([]);
  const [isAnimating, setIsAnimating] = useState(true);

  // Initialize with zero values and animate to actual values
  useEffect(() => {
    // Start with zero values
    const zeroData = genderInfoData.map(item => ({
      ...item,
      value: 0 // Set all values to 0 initially
    }));
    
    setAnimatedData(zeroData);
    
    // Animate to actual values after a short delay
    const timer = setTimeout(() => {
      setAnimatedData(genderInfoData);
      setIsAnimating(false);
    }, 200);
    
    return () => clearTimeout(timer);
  }, []); // Add dependencies here if genderInfoData can change

    return (
    <ResponsivePie
      data={animatedData}
      valueFormat={value => `${(value * 100).toFixed(1)}%`}
      // key={JSON.stringify(animatedData)}
      height={260}
      margin={{ top: 25, right: 35, bottom: 35, left: 0 }}
      fit={true}
      sortByValue={true}
      innerRadius={0.4}
      startAngle={-235}
      padAngle={3}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
       animate={true}
        motion={{ mass: 1, tension: 120, friction: 18 }} 
      borderColor={{
        from: 'color',
        modifiers: [
          [
            'darker',
            0.2
          ]
        ]
      }}
      arcLinkLabelsSkipAngle={2}
      // arcLabelsRadiusOffset={0.6} 
      arcLinkLabelsTextColor="#fdfdfdff"
      arcLinkLabelsOffset={-5}
      arcLinkLabelsDiagonalLength={20}
      arcLinkLabelsStraightLength={10}
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: 'color' }}
      arcLabelsSkipAngle={11}
      arcLabelsTextColor={{
        from: 'color',
        modifiers: [
          [
            'darker',
            '2.8'
          ]
        ]
      }}
      // motionConfig="wobbly"

      colors={{ datum: 'data.color' }}
      theme={{
        tooltip: {
          container: {
            background: 'rgba(0, 0, 0, 0.8)',
            color: '#ffffff',  // White text
            fontSize: '14px',
            borderRadius: '4px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)'
          }
        }
      }}
    // transitionMode="pushOut"
    // animate={false}
    // legends={[
    //     {
    //         anchor: 'top-right',
    //         direction: 'column',
    //         justify: false,
    //         translateX: 0,
    //         translateY: 0,
    //         itemsSpacing: -6,
    //         itemWidth: 87,
    //         itemHeight: 25,
    //         itemTextColor: '#999',
    //         itemDirection: 'left-to-right',
    //         itemOpacity: 1,
    //         symbolSize: 12,
    //         symbolShape: 'circle',
    //         effects: [
    //             {
    //                 on: 'hover',
    //                 style: {
    //                     itemTextColor: '#000'
    //                 }
    //             }
    //         ]
    //     }
    // ]}
    />
  )
})


  const GenderTable = () => {

    return (
      <TableContainer component={Paper} sx={{
        // height: 300, 
        overflow: 'auto',
        borderRadius: '12px',
        marginBottom: '14px',
        backgroundColor: '#1a1a1a',
        '& .MuiTable-root': {
          '& .MuiTableCell-root': {
            color: 'white',
            borderBottom: '1px solid #444'
          },
          '& .MuiTableRow-root:hover': {
            backgroundColor: '#333'
          }
        }
      }}
      >
        <Table sx={{ maxWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  width: 100,
                  position: 'sticky',
                  left: 0,
                  backgroundColor: '#2d2d2d',
                  zIndex: 1,
                  boxShadow: '2px 0 5px rgba(0,0,0,0.1)'
                }}
              >
                Gender
              </TableCell>
              <TableCell align="right">Percent</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {genderInfoData.map((row) => (
              <TableRow
                key={row.label}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    position: 'sticky',
                    left: 0,
                    backgroundColor: '#2d2d2d',
                    // backgroundColor: 'white',
                    zIndex: 1,
                    boxShadow: '2px 0 5px rgba(0,0,0,0.1)'
                  }}
                >
                  {row.label}
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    width: 'auto',
                    // minWidth: 0,
                    whiteSpace: 'nowrap',
                    padding: '6px 16px 6px 0'
                  }}
                >
                  {(row.value * 100).toFixed(1)}%
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  const drawerContent = () => (
    <div className="drawer-container" style={{ overflow: 'auto' }} onScroll={handleScroll}>
      <div ref={headerRef} className="sticky-header header-solid">
        <div className="header-content">
          <div className="header-left">
            <FavoriteIcon />
            <h2 className="header-title">Gender Identity</h2>
          </div>
          <div className="header-right">
            <button
              onClick={() => { setGenderInfo(false) }}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <CancelIcon sx={{ fill: "#b4b4b4ff", fontSize: "28px" }} />
            </button>
          </div>
        </div>
      </div>

      <div className="main-content">

        <div className="section">
          <div className="card">
            <div className="section-header">
              <div className="icon-holder">
                <InsertChartIcon sx={{ fontSize: "18px" }} />
              </div>
              <h3 className="section-title">Summary</h3>
            </div>
            <div className="visual-container-sm">
              <GenderPie />
            </div>
            <p className="card-text">
              This chart illustrates the gender identity distribution in the US as of 2021 according to the US Census¹.
            </p>
          </div>
        </div>


        <div className="section">
          <div className="card">
            <div className="section-header">
              <div className="icon-holder">
                <TocIcon sx={{ fontSize: "18px" }} />
              </div>
              <h3 className="section-title">Details</h3>
            </div>
            <div style={{height:'220px', marginBottom: "10px"}}>
              <GenderTable />
            </div>
            <p className="card-text">
            </p>
          </div>
        </div>


        <div className="section">
          <div className="card">
            <div className="section-header">
              <div className="icon-holder">
                <SourceIcon sx={{ fontSize: "18px" }} />
              </div>
              <h3 className="section-title">Source</h3>
            </div>
            <div className="visual-container">

            </div>
            <p className="card-text">
              {/* U.S. Census Bureau, 2023 American Community Survey (NYC) */}
              {/* <br/> */}
              [1] U.S. Census Bureau, 2021 Household Pulse Survey
            </p>
          </div>
        </div>




      </div>
    </div>
  );


  return (
    <div>
      <SwipeableDrawer
        anchor="bottom"
        open={genderInfo}
        onClose={() => setGenderInfo(false)}
        onOpen={() => setGenderInfo(true)}
        sx={{
          '& .MuiDrawer-paper': {
            backgroundColor: '#071c34ff',
            color: "white",
            borderTopRightRadius: '25px 15px',
            borderTopLeftRadius: '25px 15px',
            height: 'calc(100dvh - 95px)',
            overflow: 'auto'


          },
        }}
      >
        <div className="additionalInfoContainer">
          {drawerContent()}
        </div>
      </SwipeableDrawer>
    </div>
  )
}

export function SexualityInfoDrawer({
  sexualityInfo, setSexualityInfo,
}) {

  const headerRef = useRef(null);
  const handleScroll = useCallback((event) => {
    const scrollTop = event.target.scrollTop;
    if (headerRef.current) {
      if (scrollTop > 20) {
        headerRef.current.classList.add('header-translucent');
        headerRef.current.classList.remove('header-solid');
      } else {
        headerRef.current.classList.add('header-solid');
        headerRef.current.classList.remove('header-translucent');
      }
    }
  }, []); // Empty dependency array since we're using refs


  const SexualityTable = () => {

    return (
      <TableContainer component={Paper} sx={{
        // height: 300, 
        overflow: 'auto',
        marginBottom: '14px',
        borderRadius: '12px',
        backgroundColor: '#1a1a1a',
        '& .MuiTable-root': {
          '& .MuiTableCell-root': {
            color: 'white',
            borderBottom: '1px solid #444'
          },
          '& .MuiTableRow-root:hover': {
            backgroundColor: '#333'
          }
        }
      }}
      >
        <Table sx={{ maxWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  // width: '80px',
                  position: 'sticky',
                  left: 0,
                  backgroundColor: '#2d2d2d',
                  zIndex: 1,
                  boxShadow: '2px 0 5px rgba(0,0,0,0.1)'
                }}
              >
                Gender
              </TableCell>
              <TableCell align="right">Straight</TableCell>
              <TableCell align="right">Bisexual</TableCell>
              <TableCell align="right">Gay or Lesbian</TableCell>
              <TableCell align="right">Something Else</TableCell>
              <TableCell align="right">Don't Know</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sexualityInfoData[0].map((row) => (
              <TableRow
                key={row.Gender}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{
                    width: '80px',
                    position: 'sticky',
                    left: 0,
                    backgroundColor: '#2d2d2d',
                    // backgroundColor: 'white',
                    zIndex: 1,
                    boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
                    padding: '6px 10px 6px 10px'
                  }}
                >
                  {row.Gender}
                </TableCell>
                <TableCell align="right"> {row.Straight} </TableCell>
                <TableCell align="right"> {row.Bisexual} </TableCell>
                <TableCell align="right"> {row["Gay or Lesbian"]} </TableCell>
                <TableCell align="right"> {row["Something Else"]} </TableCell>
                <TableCell align="right"> {row["Don't Know"]} </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }


  const SexualityPie = ({ data }) => {

        const [animatedData, setAnimatedData] = useState([]);
  const [isAnimating, setIsAnimating] = useState(true);

  // Initialize with zero values and animate to actual values
  useEffect(() => {
    // Start with zero values
    const zeroData = data.map(item => ({
      ...item,
      value: 0 // Set all values to 0 initially
    }));
    
    setAnimatedData(zeroData);
    
    // Animate to actual values after a short delay
    const timer = setTimeout(() => {
      setAnimatedData(data);
      setIsAnimating(false);
    }, 200);
    
    return () => clearTimeout(timer);
  }, []); // Add dependencies here if genderInfoData can change

  return (
    <ResponsivePie
      data={animatedData}
      valueFormat={value => `${(value * 100).toFixed(1)}%`}
      // key={JSON.stringify(data)}
      height={260}
      margin={{ top: 25, right: 25, bottom: 35, left: 0 }}
      sortByValue={true}
      innerRadius={0.4}
      startAngle={-210}
      padAngle={3}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      animate={true}
      motion={{ mass: 1, tension: 120, friction: 28 }} 

      borderColor={{
        from: 'color',
        modifiers: [
          [
            'darker',
            0.2
          ]
        ]
      }}
      arcLinkLabelsSkipAngle={2}
      // arcLabelsRadiusOffset={0.6} 
      arcLinkLabelsTextColor="#fdfdfdff"
      arcLinkLabelsOffset={-5}
      arcLinkLabelsDiagonalLength={20}
      arcLinkLabelsStraightLength={10}
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: 'color' }}
      arcLabelsSkipAngle={11}
      arcLabelsTextColor={{
        from: 'color',
        modifiers: [
          [
            'darker',
            '2.8'
          ]
        ]
      }}

      colors={{ datum: 'data.color' }}
      theme={{
        tooltip: {
          container: {
            background: 'rgba(0, 0, 0, 0.8)',
            color: '#ffffff',  // White text
            fontSize: '14px',
            borderRadius: '4px',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)'
          }
        }
      }}
    // transitionMode="pushOut"
    // animate={false}
    // legends={[
    //     {
    //         anchor: 'top-right',
    //         direction: 'column',
    //         justify: false,
    //         translateX: 0,
    //         translateY: 0,
    //         itemsSpacing: -6,
    //         itemWidth: 87,
    //         itemHeight: 25,
    //         itemTextColor: '#999',
    //         itemDirection: 'left-to-right',
    //         itemOpacity: 1,
    //         symbolSize: 12,
    //         symbolShape: 'circle',
    //         effects: [
    //             {
    //                 on: 'hover',
    //                 style: {
    //                     itemTextColor: '#000'
    //                 }
    //             }
    //         ]
    //     }
    // ]}
    />
  )
}

  const drawerContent = () => (
    <div className="drawer-container" style={{ overflow: 'auto' }} onScroll={handleScroll}>
      <div ref={headerRef} className="sticky-header header-solid">
        <div className="header-content">
          <div className="header-left">
            <FavoriteIcon />
            <h2 className="header-title">Sexual Orientation</h2>
          </div>
          <div className="header-right">
            <button
              onClick={() => { setSexualityInfo(false) }}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <CancelIcon sx={{ fill: "#b4b4b4ff", fontSize: "28px" }} />
            </button>

          </div>
        </div>
      </div>

      <div className="main-content">

        <div className="section">
          <div className="card">
            <div className="section-header">
              <div className="icon-holder">
                <InsertChartIcon sx={{ fontSize: "18px" }} />
              </div>
              <h3 className="section-title">Summary</h3>
            </div>
            <Swiper
              pagination={true}
              navigation={true}
              modules={[Pagination, Navigation]}
              className="mySwiper"
              touchStartPreventDefault={false}  // Don't prevent default on touch start
              preventClicks={false}             // Allow clicks
              preventClicksPropagation={false}  // Allow click propagation
              allowSlidePrev={true}
              allowSlideNext={true}
              simulateTouch={true}
              touchMoveStopPropagation={false}  // Don't stop propagation
              style={{
                '--swiper-navigation-color': 'rgba(255, 255, 255, 0.2)',
                '--swiper-navigation-size': '22px',
              }}
            >

              {sexualityInfoData[1].map((genderRow, index) => (
                <SwiperSlide key={index}>
                  <div className="section-header" style={{ marginBottom: "0", justifyContent: "center" }}>
                    <h3 className="section-title" style={{ fontWeight: 600 }}>{genderRow.Gender}</h3>
                  </div>
                  <div className="visual-container-sm">
                    <SexualityPie data={genderRow.data} />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <p className="card-text">
              This chart illustrates the sexual orientation distribution in the US as of 2021¹.
            </p>
          </div>
        </div>


        <div className="section">
          <div className="card">
            <div className="section-header">
              <div className="icon-holder">
                <TocIcon sx={{ fontSize: "18px" }} />
              </div>
              <h3 className="section-title">Details</h3>
            </div>
            <div style={{height:'265px', marginBottom: "10px"}}>
              <SexualityTable />
            </div>
            <p className="card-text">
            </p>
          </div>
        </div>


        <div className="section">
          <div className="card">
            <div className="section-header">
              <div className="icon-holder">
                <SourceIcon sx={{ fontSize: "18px" }} />
              </div>
              <h3 className="section-title">Source</h3>
            </div>
            <div className="visual-container">

            </div>
            <p className="card-text">
              [1] U.S. Census Bureau, 2021 Household Pulse Survey
            </p>
          </div>
        </div>




      </div>
    </div>
  );


  return (
    <div>
      <SwipeableDrawer
        anchor="bottom"
        open={sexualityInfo}
        onClose={() => setSexualityInfo(false)}
        onOpen={() => setSexualityInfo(true)}
        sx={{
          '& .MuiDrawer-paper': {
            backgroundColor: '#071c34ff',
            color: "white",
            borderTopRightRadius: '25px 15px',
            borderTopLeftRadius: '25px 15px',
            height: 'calc(100dvh - 95px)',
            overflow: 'auto'


          },
        }}
      >
        <div className="additionalInfoContainer">
          {drawerContent()}
        </div>
      </SwipeableDrawer>
    </div>
  )
}



export function MarriageInfoDrawer({
  marriageInfo, setMarriageInfo
}) {

   const headerRef = useRef(null);
   const handleScroll = useCallback((event) => {
     const scrollTop = event.target.scrollTop;
     if (headerRef.current) {
       if (scrollTop > 20) {
         headerRef.current.classList.add('header-translucent');
         headerRef.current.classList.remove('header-solid');
       } else {
         headerRef.current.classList.add('header-solid');
         headerRef.current.classList.remove('header-translucent');
       }
     }
   }, []); // Empty dependency array since we're using refs

  const MarriageLine = ({ data }) => {

 const [animatedData, setAnimatedData] = useState([]);
  const [isAnimating, setIsAnimating] = useState(true);
  
  // Use the data prop that's being passed in
  const actualData = data;
  
  // Initialize with zero values and animate to actual values
  useEffect(() => {
    // Only run if we have data
    if (!data || data.length === 0) return;
    
    // Start with zero values
    const zeroData = actualData.map(serie => ({
      ...serie,
      data: serie.data.map(point => ({ ...point, y: 0 }))
    }));
    
    setAnimatedData(zeroData);
    
    // Animate to actual values after a short delay
    const timer = setTimeout(() => {
      setAnimatedData(actualData);
      setIsAnimating(false);
    }, 200);
    
    return () => clearTimeout(timer);
  }, [data]); // Re-animate when data prop changes


    return(
    <ResponsiveLine
      data={animatedData}
      height={320}
      margin={{ top: 30, right: 30, bottom: 90, left: 55 }}
      // margin={{ top: 25, right: 110, bottom: 50, left: 50 }}
      xScale={{ type: 'point' }}
      yScale={{
        type: 'linear',
        min: 'auto',
        max: 80
      }}
      yFormat={value => `${value.toFixed(1)}%`}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: 'Age Group',
        legendOffset: 36,
        legendPosition: 'middle'
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: 'Percentage',
        legendOffset: -40,
        legendPosition: 'middle'
      }}
      curve="cardinal"
      pointSize={10}
      pointColor="#ffffff"
      pointBorderWidth={1}
      pointBorderColor={{ from: 'serieColor' }}
      pointLabelYOffset={-12}
      enableTouchCrosshair={true}
      useMesh={true}
      colors={(serie) => {
        const colorMap = {
          'Never Married': '#fb6f92',
          'Divorced': '#00b4d8',
          'Separated': '#0077b6',
          'Widowed': '#03045e',
          'Now Married': '#bf0603'
        };
        return colorMap[serie.id] || '#666666';
      }}
      lineWidth={3}
      enablePointLabel={false}
      animate={true}
      motionConfig="wobbly"
      tooltip={({ point }) => (
      <div
        style={{
          background: 'rgba(0, 0, 0, 0.8)',
          color: '#ffffff',
          fontSize: '14px',
          borderRadius: '4px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
          padding: '8px 12px'
        }}
      >
        {point.data.yFormatted}
      </div>
    )}
      // Removed custom tooltip - using default with yFormat
      theme={{
          background: 'transparent',
          text: {
            fill: '#ffffff',
            fontSize: 11
          },
          axis: {
            domain: {
              line: {
                stroke: '#777777',
                strokeWidth: 1
              }
            },
            legend: {
              text: {
                fill: '#ffffff',
                fontSize: 12,
                fontWeight: 500
              }
            },
            ticks: {
              line: {
                stroke: '#777777',
                strokeWidth: 1
              },
              text: {
                fill: '#ffffff',
                fontSize: 11
              }
            }
          },
          grid: {
            line: {
              stroke: '#444444',
              strokeWidth: 1,
              strokeDasharray: '2 2'
            }
          },
          crosshair: {
            line: {
              stroke: '#ffffff',
              strokeWidth: 1,
              strokeOpacity: 0.35
            }
          }
        }}
   legends={[
  {
    anchor: 'bottom',
    direction: 'row',
    translateX: -20,
    translateY: 70,
    itemsSpacing: 30,
    itemDirection: 'left-to-right',
    itemWidth: 40,
    itemHeight: 16,
    itemOpacity: 0.85,
    symbolSize: 6,
    symbolSpacing: 3,
    symbolShape: 'circle',
    symbolBorderColor: 'rgba(0, 0, 0, .5)',
    itemTextColor: '#ffffff',
    data: [
      // First 3 items
      { id: 'Now Married', label: 'Married', color: '#bf0603' },
      { id: 'Never Married', label: 'Never', color: '#fb6f92' },
      { id: 'Divorced', label: 'Divorced', color: '#00b4d8' }
    ],
    effects: [
      {
        on: 'hover',
        style: {
          itemBackground: 'rgba(0, 0, 0, .1)',
          itemOpacity: 1
        }
      }
    ]
  },
  {
    anchor: 'bottom',
    direction: 'row',
    translateX: -20,
    translateY: 90,
    itemsSpacing: 30,
    itemDirection: 'left-to-right',
    itemWidth: 40,
    itemHeight: 16,
    itemOpacity: 0.85,
    symbolSize: 6,
    symbolSpacing: 3,
    symbolShape: 'circle',
    symbolBorderColor: 'rgba(0, 0, 0, .5)',
    itemTextColor: '#ffffff',
    data: [
      // Last 2 items
      { id: 'Separated', label: 'Separated', color: '#0077b6' },
      { id: 'Widowed', label: 'Widowed', color: '#03045e' }
    ]
  }
]}
      // legends={[
      //   {
      //     anchor: 'bottom-right',
      //     direction: 'column',
      //     justify: false,
      //     translateX: 100,
      //     translateY: 0,
      //     itemsSpacing: 0,
      //     itemDirection: 'left-to-right',
      //     itemWidth: 80,
      //     itemHeight: 20,
      //     itemOpacity: 0.75,
      //     symbolSize: 12,
      //     symbolShape: 'circle',
      //     symbolBorderColor: 'rgba(0, 0, 0, .5)',
      //     effects: [
      //       {
      //         on: 'hover',
      //         style: {
      //           itemBackground: 'rgba(0, 0, 0, .03)',
      //           itemOpacity: 1
      //         }
      //       }
      //     ]
      //   }
      // ]}
    />
  )
}

const MarriageTable = ({ data }) => {
  const ageGroups = ["20-34", "35-44", "45-54", "55-64"];

  const handleTouchStart = (e) => {
    e.stopPropagation();
  };

  const handleTouchMove = (e) => {
    e.stopPropagation();
  };

  return (
    <TableContainer
      component={Paper}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      sx={{
        overflow: 'auto',
        marginBottom: '140px',
        borderRadius: '12px',
        backgroundColor: '#1a1a1a',
        '& .MuiTable-root': {
          '& .MuiTableCell-root': {
            color: 'white',
            borderBottom: '1px solid #444'
          },
          '& .MuiTableRow-root:hover': {
            backgroundColor: '#333'
          }
        }
      }}
    >
      <Table sx={{ maxWidth: 650 }} size="small" aria-label="marriage statistics table">
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                position: 'sticky',
                left: 0,
                backgroundColor: '#2d2d2d',
                zIndex: 1,
                boxShadow: '2px 0 5px rgba(0,0,0,0.1)'
              }}
            >
              Marital Status
            </TableCell>
            {ageGroups.map((ageGroup) => (
              <TableCell key={ageGroup} align="right" sx={{ width: '80px', lineHeight: '15px' }}>
                {ageGroup} yrs
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((category) => (
            <TableRow
              key={category.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell
                component="th"
                scope="row"
                sx={{
                  width: '80px',
                  position: 'sticky',
                  left: 0,
                  backgroundColor: '#2d2d2d',
                  zIndex: 1,
                  boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
                  fontWeight: 500,
                  padding: '6px 10px 6px 10px'
                }}
              >
                {category.id}
              </TableCell>
              {category.data.map((dataPoint) => (
                <TableCell
                  key={dataPoint.x}
                  align="right"
                  sx={{ width: '80px' }}
                >
                  {dataPoint.y.toFixed(1)}%
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

  
  

  const drawerContent = () => (
    <div className="drawer-container" style={{ overflow: 'auto' }} onScroll={handleScroll}>
      <div ref={headerRef} className="sticky-header header-solid">
        <div className="header-content">
          <div className="header-left">
            <FavoriteIcon />
            <h2 className="header-title">Marital Status</h2>
          </div>
          <div className="header-right">
            <button
              onClick={() => { setMarriageInfo(false) }}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <CancelIcon sx={{ fill: "#b4b4b4ff", fontSize: "28px" }} />
            </button>
          </div>
        </div>
      </div>

      <div className="main-content">


        <div className="section">
          <div className="card">
            <div className="section-header">
              <div className="icon-holder">
                <InsertChartIcon sx={{ fontSize: "18px" }} />
              </div>
              <h3 className="section-title">Summary</h3>
            </div>
            <Swiper
              pagination={true}
              navigation={true}
              className="mySwiper"
              touchStartPreventDefault={false}  // Don't prevent default on touch start
              preventClicks={false}             // Allow clicks
              preventClicksPropagation={false}  // Allow click propagation
              allowSlidePrev={true}
              allowSlideNext={true}
              simulateTouch={true}
              touchMoveStopPropagation={false}  // Don't stop propagation
              modules={[Pagination, Navigation]}
              style={{
                '--swiper-navigation-color': 'rgba(255, 255, 255, 0.2)',
                '--swiper-navigation-size': '22px',
              }}
            >
                            <SwiperSlide>
                <div className="section-header" style={{ marginBottom: "0", justifyContent: "center" }}>
                  <h3 className="section-title" style={{ fontWeight: 600 }}>Women</h3>
                </div>
                <div style={{height: '360px'}}>
                  <MarriageLine data={marriageInfoData.femaleData} />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="section-header" style={{ marginBottom: "0", justifyContent: "center" }}>
                  <h3 className="section-title" style={{ fontWeight: 600 }}>Men</h3>
                </div>
                <div style={{height: '360px'}}>
                  <MarriageLine data={marriageInfoData.maleData} />
                </div>
              </SwiperSlide>
            </Swiper>
            <p className="card-text">
              This chart illustrates the marital status distribution across age in the US as of 2023¹.
            </p>
          </div>
        </div>


        <div className="section">
          <div className="card">
            <div className="section-header">
              <div className="icon-holder">
                <TocIcon sx={{ fontSize: "18px" }} />
              </div>
              <h3 className="section-title">Details</h3>
            </div>
            <div className="visual-container">
              <Swiper
              pagination={true}
              navigation={true}
              className="mySwiper"
              touchStartPreventDefault={false}  // Don't prevent default on touch start
              preventClicks={false}             // Allow clicks
              preventClicksPropagation={false}  // Allow click propagation
              allowSlidePrev={true}
              allowSlideNext={true}
              simulateTouch={true}
              touchMoveStopPropagation={false}  // Don't stop propagation
              modules={[Pagination, Navigation]}
              style={{
                '--swiper-navigation-color': 'rgba(255, 255, 255, 0.2)',
                '--swiper-navigation-size': '22px',
              }}
            >
             
              <SwiperSlide>
                <div className="section-header" style={{ marginBottom: "25px", justifyContent: "center" }}>
                  <h3 className="section-title" style={{ fontWeight: 600 }}>Women</h3>
                </div>
                <div style={{ height: '320px', marginBottom: '20px' }}>
                  <MarriageTable data={marriageInfoData.femaleData} />
                </div>
              </SwiperSlide>

               <SwiperSlide>
                <div className="section-header" style={{ marginBottom: "25px", justifyContent: "center" }}>
                  <h3 className="section-title" style={{ fontWeight: 600 }}>Men</h3>
                </div>
                <div style={{ height: '320px', marginBottom: '20px' }}>
                  <MarriageTable data={marriageInfoData.maleData} />
                </div>
              </SwiperSlide>

            </Swiper>
            </div>
            <p className="card-text">
            </p>
          </div>
        </div>


        <div className="section">
          <div className="card">
            <div className="section-header">
              <div className="icon-holder">
                <SourceIcon sx={{ fontSize: "18px" }} />
              </div>
              <h3 className="section-title">Source</h3>
            </div>
            <div className="visual-container">

            </div>
            <p className="card-text">
              [1] U.S. Census Bureau, 2019-2023 American Community Survey (NYC)
            </p>
          </div>
        </div>



        {/* Additional menu items */}

      </div>
    </div>
  );


  return (
    <div>
      <SwipeableDrawer
        anchor="bottom"
        open={marriageInfo}
        onClose={() => setMarriageInfo(false)}
        onOpen={() => setMarriageInfo(true)}
        sx={{
          '& .MuiDrawer-paper': {
            backgroundColor: '#071c34ff',
            color: "white",
            borderTopRightRadius: '25px 15px',
            borderTopLeftRadius: '25px 15px',
            height: 'calc(100dvh - 95px)',
            overflow: 'auto'
          },
        }}
      >
        <div className="additionalInfoContainer">
          {drawerContent()}
        </div>
      </SwipeableDrawer>
    </div>
  )
}